module.exports = __webpack_public_path__ + "img/map_location_rose_selected.20ab219c.svg";